import "../LandingPage.css";

export default function Corporate() {
  return (
    <>
      <section className="need-section padding-bottom" id="corporateSection">
        <div className="container">
          <div className="section-title">
            <h2> Corporate Commuter </h2>
          </div>
          <div className="row responsive-screen-991">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="need-details">
                <p className="need-details-text">
                  In any large organization, about 30 to 40% of the employees
                  depend upon the company arranged transportation services for
                  their commute to office and back home. Companies spends
                  significant amount of money to provide these services to
                  employees. Transportation Services are complex, and
                  requirements changes dynamically, it involves
                  multi-disciplinary team to manage it. Late night shifts of
                  employees, specifically female employees add more
                  responsibilities on the transport team to bring them safely to
                  work and back home. Any disruption in transport services
                  results in loss of productive time, loss of revenue and
                  reputation also.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="need-img">
                <img
                  // src="/assets/images/123.jpg"
                  src="/assets/images/corporateCommuterImage.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <br />

      <section className="features-section problem-section padding-bottom">
        <div className="container">
          <div className="section-title">
            <h2> The Problem </h2>
            <p>
              With implementing Employee transport Automation, companies can
              manage transport operations more efficiently, ensuring employee
              safety and save on cost by cutting down on inefficiency of manual
              system like,
            </p>
          </div>
          <div className="row">
            {[
              { img: 1, title: "Employee Safety" },
              { img: 2, title: "Inefficient Routing" },
              {
                img: 3,
                title:
                  "Longer commute time, resulting in tired and fatigued employees reaching office",
              },
              { img: 4, title: "Lack of real time visibility of vehicles" },
              {
                img: 5,
                title:
                  "Manual coordination with drivers and employee with high back and forth phone calls",
              },
              {
                img: 6,
                title:
                  "Manual Billing and reconciliation with excel report generation and maintenance",
              },
              {
                img: 7,
                title: "No in-depth Analytics on the transport operations",
              },
            ].map((p, idx) => (
              <div
                className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12"
                key={idx}
              >
                <div className="feature-box">
                  <div className="feature-inner">
                    <div className="feature-img problem-ic">
                      <img
                        src={`/assets/images/Problem-ic-${p.img}.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="feature-details">
                      <h3>{p.title}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="schools-section corporate-section padding-bottom">
        <div className="container">
          <div className="section-title">
            <h2>
              {" "}
              Little Corporate Commuter is answer to all these issues companies
              faces{" "}
            </h2>
          </div>
          <div className="row justify-content-center">
            {[
              {
                img: 1,
                title: "Intelligent AI",
                text: "Visually Create Intelligent AI Powered Routing",
              },
              {
                img: 2,
                title: "Driver App",
                text: "Driver App to show them their routes, provide navigation and pickup time for each employee",
              },
              {
                img: 3,
                title: "SOS",
                text: "Speed Alerts and SOS features in driver and rider app for employee’s safety and security",
              },
              {
                img: 4,
                title: "Dashborad",
                text: "Smart Dashboards for the company transport manager to track real time live locations of all vehicles",
              },
              {
                img: 5,
                title: "Rider App",
                text: "Rider App for Employees showing them exact location of the vehicle and estimated time of arrival for their pickup or drop",
              },
              {
                img: 6,
                title: "Alert",
                text: "Proximity Alerts to employees once their vehicles are nearby to their pickup location",
              },
              {
                img: 7,
                title: "Analytics",
                text: "In Depth Analytics of the entire transport department with real time Data",
              },
            ].map((c, idx) => (
              <div
                className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 d-flex"
                key={idx}
              >
                <div className="benefits-box">
                  <div className="benefits-inner schools-inner">
                    <div className="benefits-img corporate-img">
                      <img
                        src={`/assets/images/corporate-img-${c.img}.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="benefits-details">
                      <h3>{c.title}</h3>
                      <p>{c.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
